import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';


import {IonicStorageModule} from "@ionic/storage";

import {MyApp} from './app.component';
import {HomePage} from '../pages/home/home';
import {LoginPage} from "../pages/login/login";
import {OrderListPage} from "../pages/order-list/order-list";
import {AuthService} from "../services/AuthService";
import {HttpClientModule} from "@angular/common/http";
import {OrderService} from "../services/OrderService";
import {OrderViewPage} from "../pages/order-view/order-view";
import {OperationService} from "../services/OperationService";
import {StoreService} from "../services/StoreService";
import {DateService} from "../services/DateService";
import {PhotoService} from "../services/PhotoService";
import {QuotaPage} from "../pages/quota/quota";
import {ChartsModule} from "ng2-charts";
import {GalleryPage} from "../pages/gallery/gallery";
import {IonicImageViewerModule} from "ionic-img-viewer";
import {LogaDayService} from "../services/LogaDayService";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {DatePipe, registerLocaleData} from "@angular/common";
import {MonthlyPlanningPage} from "../pages/order-list/monthly-view";
import {KpiService} from "../services/KpiService";

import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import {AdditionalTimesViewPage} from "../pages/order-view/additional/additional-view";
import {KpiSheetsPage} from "../pages/kpi/kpi";
import {SafePipe} from "../pipe/SafePipe";
import {LocupaChartsServiceProvider} from '../providers/locupa-charts-service/locupa-charts-service';
import {DynamicColDirective} from "../directive/DynamicColDirective";
import {AppVersion} from "@ionic-native/app-version/ngx";
import {PcheckService} from "../services/PcheckService";
import {OperationsOverviewPage} from "../pages/operatons-overview/operatons-overview";
import {MenuItemsProvider} from '../providers/menu-items/menu-items';

import {FieldTeamActivityReportPage} from "../pages/field-team-activity-report/field-team-activity-report";
import {OperationDashboardPage} from "../pages/operation-dashboard/operation-dashboard";
import {OrderEditPage} from "../pages/order-edit/order-edit";
import {LocupaUtilsServiceProvider} from '../providers/locupa-utils-service/locupa-utils-service';
import {EpochToDatePipe} from "../pipes/epoch-to-date/epoch-to-date";
import {StoreDirectoryPage} from "../pages/store-directory/store-directory";
import {StoreDashboardPage} from "../pages/store-dashboard/store-dashboard";
import {StartOrderPage} from "../pages/start-order/start-order";
import {ResourcePlanningService} from "../services/ResourcePlanningService";
import {OrderEditDwstModalPage} from "../pages/order-edit-dwst-modal/order-edit-dwst-modal";
import {SlotsPlanningProgressReportPage} from "../pages/slots-planning-progress-report/slots-planning-progress-report";
import {QuotaBudgetPage} from "../pages/quota/quota-budget";
import {DailyViewPage} from "../pages/order-list/daily-view";
import {Locupa2Service} from "../services/Locupa2Service";
import {AgencyConfigService} from "../services/AgencyConfigService";
import {AgencyLogoDirective} from "../directive/agency-logo.directive";
import {PowerBIService} from "../services/PowerBIService";

registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    OrderListPage,
    OrderEditPage, OrderEditDwstModalPage,
    StartOrderPage,
    OrderViewPage,
    QuotaPage, QuotaBudgetPage, FieldTeamActivityReportPage,
    GalleryPage,
    SafePipe, OperationsOverviewPage, OperationDashboardPage, EpochToDatePipe, StoreDirectoryPage, StoreDashboardPage, SlotsPlanningProgressReportPage,
    MonthlyPlanningPage, DailyViewPage, AdditionalTimesViewPage, KpiSheetsPage, DynamicColDirective, AgencyLogoDirective
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {
      monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    }),
    IonicStorageModule.forRoot({
      name: '__locupa',
    }),
    ChartsModule,
    IonicImageViewerModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    StartOrderPage,
    OrderListPage,
    OrderEditPage,
    OrderViewPage,
    OperationsOverviewPage,
    OperationDashboardPage,
    QuotaPage, QuotaBudgetPage, SlotsPlanningProgressReportPage,
    GalleryPage,
    OrderEditDwstModalPage,
    MonthlyPlanningPage, DailyViewPage,
    StoreDirectoryPage, StoreDashboardPage,
    AdditionalTimesViewPage, KpiSheetsPage, FieldTeamActivityReportPage
  ],
  providers: [
    AgencyConfigService, AuthService,
    OrderService,
    PcheckService,
    OperationService,
    StoreService,
    DateService,
    PhotoService,
    LogaDayService,
    ResourcePlanningService,
    StatusBar,
    SplashScreen,
    InAppBrowser,
    DatePipe, SafePipe, EpochToDatePipe,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {provide: LOCALE_ID, useValue: "fr-FR"},
    KpiService,
    LocupaChartsServiceProvider,
    DynamicColDirective,
    AppVersion,
    MenuItemsProvider,
    LocupaUtilsServiceProvider,
    Locupa2Service,
    AgencyLogoDirective,
    PowerBIService
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts